import { useState } from 'react'

function Accordian({ title, content, bordered = false }) {  
    const [showContent, setShowContent] = useState(false);
    return (
        <>
            <div className={`cursor-pointer py-[10px] mb-1 ${bordered ? 'border border-[#EBEBEB] px-[10px]' : ''}`} onClick={() => setShowContent(!showContent)}>
                <div
                    className='select-none flex justify-between items-center' >
                    <p className=' font-light'> { title } </p> 
                        <div>
                            {
                                showContent ?
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 p-1 text-primary-color rounded-full" style={{ background : 'rgba(57, 20, 0, 0.2)' }}>
                                    <path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                                </svg>
                                :
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 p-1 text-primary-color rounded-full" style={{ background : 'rgba(57, 20, 0, 0.2)' }}>
                                    <path fillRule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clipRule="evenodd" />
                                </svg>
                            }
                        </div>
                </div>
                {
                    <div className={`overflow-hidden transition-all duration-300 ease-in-out ${showContent ? 'max-h-96' : 'max-h-0'}`}>
                        <p className='text-[0.7rem] mt-3' dangerouslySetInnerHTML={{'__html' : content}} />
                    </div>
                }
            </div>
        </>
    )
}

export default Accordian